import { mixins, styled } from '@bob/library'
import { themeVars } from 'leds'

import { MainTopbarAuth } from './Auth/MainTopbarAuth'
import { MainTopbarRegionModal } from './RegionModal/MainTopbarRegionModal'

export const StyledRegionModalButton = styled(MainTopbarRegionModal)`
  ${mixins.media.max.tablet} {
    display: none;
  }
`

export const StyledAuthButton = styled(MainTopbarAuth)`
  ${mixins.media.max.tablet} {
    display: none;
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const ButtonTertiary = styled.button`
  ${mixins.cta.tertiary('black')}

  &:hover {
    path {
      stroke: ${themeVars.color.blue6} !important;
    }
  }
`
